export default "data:image/webp;base64,UklGRiYAAABXRUJQVlA4TBkAAAAvJ4AGAAVhttEUzh/2FPqc3qnof27mwxzMAA=="